(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  if (!customElements.get('subcategory-carousel')) {
    class SubcategoryCarousel extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();

        this.abortController = new AbortController();
        const { signal } = this.abortController;

        this.track = this.querySelector('[data-subcategory-track]');
        this.prevButton = this.querySelector('[data-subcategory-prev]');
        this.nextButton = this.querySelector('[data-subcategory-next]');

        if (!this.track) return;

        this.prevButton?.addEventListener('click', () => this.scrollByPage(-1), { signal });
        this.nextButton?.addEventListener('click', () => this.scrollByPage(1), { signal });
        this.track.addEventListener('scroll', () => this.updateControls(), { passive: true, signal });

        this.querySelectorAll('[data-subcategory-filter]').forEach((button) => {
          button.addEventListener('click', (event) => this.handleFilterClick(event), { signal });
        });

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.updateControls());
          this.resizeObserver.observe(this.track);
        } else {
          window.addEventListener('resize', () => this.updateControls(), { signal });
        }

        requestAnimationFrame(() => {
          this.updateControls();
          this.scrollActiveCardIntoView();
        });
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
      }

      get filterParam() {
        return this.dataset.filterParam || 'filter.p.m.custom.sub_category';
      }

      getScrollAmount() {
        if (!this.track) return 0;
        const styles = window.getComputedStyle(this.track);
        const gap = Number.parseFloat(styles.columnGap || styles.gap || '0');
        // Scroll exactly one "page" of 4 cards
        return this.track.clientWidth + gap;
      }

      scrollByPage(direction) {
        if (!this.track) return;
        this.track.scrollBy({
          left: this.getScrollAmount() * direction,
          behavior: 'smooth',
        });
      }

      updateControls() {
        if (!this.track || !this.prevButton || !this.nextButton) return;

        const maxScrollLeft = Math.max(this.track.scrollWidth - this.track.clientWidth, 0);
        const shouldHideControls = maxScrollLeft <= 1;

        this.prevButton.hidden = shouldHideControls;
        this.nextButton.hidden = shouldHideControls;

        if (shouldHideControls) return;

        this.prevButton.disabled = this.track.scrollLeft <= 1;
        this.nextButton.disabled = this.track.scrollLeft >= maxScrollLeft - 1;
      }

      scrollActiveCardIntoView() {
        const activeCard = this.querySelector('[data-subcategory-card][data-active="true"]');
        if (!(activeCard instanceof HTMLElement)) return;
        activeCard.scrollIntoView({ block: 'nearest', inline: 'center' });
      }

      handleFilterClick(event) {
        const button = event.currentTarget;
        if (!(button instanceof HTMLElement)) return;

        // Update active state immediately for visual feedback
        this.querySelectorAll('[data-subcategory-card]').forEach((card) => {
          card.classList.remove('is-active');
          card.dataset.active = 'false';
          card.setAttribute('aria-pressed', 'false');
        });
        button.classList.add('is-active');
        button.dataset.active = 'true';
        button.setAttribute('aria-pressed', 'true');

        const url = new URL(window.location.href);
        const value = button.dataset.subcategoryValue || '';

        url.searchParams.delete('page');

        if (value) {
          url.searchParams.set(this.filterParam, value);
        } else {
          url.searchParams.delete(this.filterParam);
        }

        const nextUrl = url.toString();
        if (nextUrl === window.location.href) return;

        const facetsForm = this.closest('results-list')?.querySelector('facets-form-component');

        if (facetsForm && typeof facetsForm.updateFiltersByURL === 'function') {
          facetsForm.updateFiltersByURL(nextUrl);
          return;
        }

        window.location.assign(nextUrl);
      }
    }

    customElements.define('subcategory-carousel', SubcategoryCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
